import React from 'react'
import { SVGProps } from './types'

export const DeviceShare: React.FC<SVGProps> = ({
  size = 24,
  width,
  height,
  color = 'currentColor',
  onClick,
  strokeWidth = 2,
}) => {
  const resolvedWidth = width ?? size
  const resolvedHeight = height ?? size

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={resolvedWidth}
      height={resolvedHeight}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick && (() => onClick())}
    >
      <path d="M12 2v13" />
      <path d="m16 6-4-4-4 4" />
      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    </svg>
  )
}
